var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { useSlots, defineComponent, computed } from "vue";
function useSlotsExists(keys) {
  const slots = useSlots();
  function getSlots(k, v) {
    var _a;
    return (_a = slots[k]) == null ? void 0 : _a.call(slots, v ?? {});
  }
  __name(getSlots, "getSlots");
  const SlotRender = defineComponent({
    props: {
      slotName: {
        type: String,
        required: !0
      }
    },
    setup(props) {
      return { slotName: props.slotName };
    },
    render(ctx) {
      return getSlots(ctx.slotName, attrsKebabToCamel(ctx.$attrs));
    }
  });
  return computed(() => {
    const slotsExistsResult = {};
    return keys && keys.forEach((key) => {
      var _a, _b;
      slotsExistsResult[key] = !!((_b = (_a = slots[key]) == null ? void 0 : _a.call(slots)) != null && _b.length);
    }), { SlotRender, slots, getSlots, ...slotsExistsResult };
  });
}
__name(useSlotsExists, "useSlotsExists");
function kebabToCamel(str) {
  return str.replace(/-([a-zA-Z0-9])/g, (_, char) => char.toUpperCase());
}
__name(kebabToCamel, "kebabToCamel");
function attrsKebabToCamel(attrs) {
  return Object.assign(
    {},
    attrs,
    Object.fromEntries(
      Object.entries(attrs).map(([key, value]) => [kebabToCamel(key), value])
    )
  );
}
__name(attrsKebabToCamel, "attrsKebabToCamel");
export {
  useSlotsExists
};
//# sourceMappingURL=useSlotsExists.js.map
